import React from 'react';

interface SectionBackgroundProps {
  variant?: 'left' | 'right' | 'both';
}

const SectionBackground: React.FC<SectionBackgroundProps> = ({ variant = 'both' }) => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Left side decorations */}
      {(variant === 'left' || variant === 'both') && (
        <>
          <div className="absolute -left-40 top-1/4 w-96 h-96 bg-gradient-to-r from-[#0139B7] to-[#0156e0] rounded-full 
            filter blur-3xl opacity-10 animate-float" />
          <div className="absolute -left-20 bottom-1/4 w-64 h-64 bg-gradient-to-r from-[#0156e0] to-[#0139B7] rounded-full 
            filter blur-3xl opacity-10 animate-float-delayed" />
        </>
      )}

      {/* Right side decorations */}
      {(variant === 'right' || variant === 'both') && (
        <>
          <div className="absolute -right-40 top-1/3 w-96 h-96 bg-gradient-to-r from-[#0139B7] to-[#0156e0] rounded-full 
            filter blur-3xl opacity-10 animate-float-delayed" />
          <div className="absolute -right-20 bottom-1/3 w-64 h-64 bg-gradient-to-r from-[#0156e0] to-[#0139B7] rounded-full 
            filter blur-3xl opacity-10 animate-float" />
        </>
      )}
    </div>
  );
}

export default SectionBackground;